import {useEffect, useMemo, useState} from 'react';
import {t} from '../../../../common/getTranslations';
import {useDialog} from '../../../../dialog/useDialog.hook';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {getTicketPopupOn, saveTicketPopupOn} from '../util/ticketPopupOn';

export function useTicketPopupOnDialog(isMobile: boolean) {
  const {DialogWrapper, Dialog, showDialog, hideDialog} = useDialog({
    isMobile,
  });
  const [ticketPopupOn, setTicketPopupOn] = useState<boolean | undefined>(
    getTicketPopupOn()
  );
  useEffect(() => {
    if (getTicketPopupOn() !== ticketPopupOn) {
      saveTicketPopupOn(!!ticketPopupOn);
    }
  }, [ticketPopupOn]);
  const dialogElem = useMemo(() => {
    return (
      <DialogWrapper
        {...putTiaraObjectProps({
          click: {layer1: '설정'},
        })}
      >
        <Dialog.Dimmed />
        <Dialog.Label className="mb-16pxr">
          {t('more_settings_tickets_popup')}
        </Dialog.Label>
        <Dialog.List className="space-y-0">
          <Dialog.Option
            isChecked={ticketPopupOn}
            onClick={e =>
              LOG_CLICK_EVENT('이용권사용확인_클릭', e, () => {
                setTicketPopupOn(true);
                hideDialog();
              })
            }
            {...putTiaraObjectProps({
              click: {
                copy: 'On',
              },
            })}
          >
            {t('more_settings_on')}
          </Dialog.Option>
          <Dialog.Option
            isChecked={!ticketPopupOn}
            onClick={e =>
              LOG_CLICK_EVENT('이용권사용확인_클릭', e, () => {
                setTicketPopupOn(false);
                hideDialog();
              })
            }
            {...putTiaraObjectProps({
              click: {
                copy: 'Off',
              },
            })}
          >
            {t('more_settings_off')}
          </Dialog.Option>
        </Dialog.List>
        <Dialog.BottomCombination>
          <Dialog.Button
            onClick={e =>
              LOG_CLICK_EVENT('이용권사용확인_클릭', e, () => hideDialog())
            }
            {...putTiaraObjectProps({
              click: {
                copy: '취소',
              },
            })}
          >
            {t('common_cancel_button')}
          </Dialog.Button>
        </Dialog.BottomCombination>
      </DialogWrapper>
    );
  }, [Dialog, DialogWrapper, hideDialog, ticketPopupOn]);

  return {
    showDialog,
    hideDialog,
    ticketPopupOnDialog: dialogElem,
    ticketPopupOn,
  };
}
